var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYolk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f8d164;\n      }\n\n      .st1 {\n        fill: #e1ad3b;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #bc8b2b;\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #e0e1e2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 180.4,
    cy: 180.5,
    r: 128.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284.1,105.1c10.9,18.8,17.1,40.7,17.1,64,0,70.8-57.4,128.2-128.2,128.2s-80.4-20.8-103.7-52.8c22.1,38.4,63.6,64.2,111.1,64.2,70.8,0,128.2-57.4,128.2-128.2s-9.1-54.3-24.5-75.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,182c-25.8,25.8-68,26.7-85.8,11.8-20.9-17.4-19.5-62.7,3-91.4,21.9-28,62.9-37.1,89.7-11.8s19.7,64.9-6.9,91.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.6,119.3c.5-2.6,5.6-5.8,16.9-2.5,11.4,3.3,12.5,16.3,13.4,20.9s6.5,31.4,9.6,48.8c2.7-7.8,10.2-39,14.3-44.3s9.8-8.5,16.7-7.8,12.3,3.4,14.7,11.6c5.1,17.6,17.6,55,23.4,69.3.4-13.4.9-56.8.9-66.4s-.7-35.4-1.8-48.3c-.5-5.6-1.3-15.1.9-18s5.8-6.8,16.7-4.2c9.6,2.2,8,11.6,8,18.9,0,14.7.7,56.1.7,68.4s3.1,82.2,2.9,88c-.2,6.7-4.6,14.8-9.6,16.9-6.2,2.7-13.5,2.9-20.5-2.7-7.8-6.2-18.7-29.2-25.6-50.6-2.5-7.6-10.9-31.6-15.1-40.1-1.1,10.2-4,28.3-5.8,46.3-1.7,16.9-3.2,42.8-5.3,46.8-3.3,6.2-11.8,10-18.9,10.9s-12.9-1.3-13.6-14.7c-.7-13.4-5.9-58.8-7.1-69.5-2.7-22.5-6.5-43.9-10.2-57.9s-6.5-13.6-5.3-19.8h-.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.2,203.5c1.9,16.5,5.8,51.5,6.4,63,.7,13.4,6.7,15.6,13.6,14.7,7.1-.9,15.6-4.7,18.9-10.9,2.1-4,3.7-29.9,5.3-46.8,1.2-12.4,3-24.9,4.3-34.8-14.7,10.9-32.8,15.4-48.6,14.8h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.9,165.6c0-12.3-.7-53.7-.7-68.4s1.6-16.7-8-18.9c-10.9-2.5-14.5,1.3-16.7,4.2-2.2,2.9-1.4,12.5-.9,18,1.1,12.9,1.8,38.8,1.8,48.3s-.4,53-.9,66.4c-4.6-11.4-13.5-37.5-19.5-56.6-4,8.4-9.7,16.3-16.7,23.3s-2,1.9-3,2.8c4.4,10.7,9.9,26.5,11.8,32.5,6.9,21.4,17.8,44.3,25.6,50.6,7,5.6,14.3,5.3,20.5,2.7,5-2.1,9.4-10.2,9.6-16.9.2-5.8-2.9-75.7-2.9-88h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolk);
export default __webpack_public_path__ + "static/media/yolk.f6a75ca37292a59f7ad6da67be4d3da8.svg";
export { ForwardRef as ReactComponent };